import { BitrixVue } from 'ui.vue';
import type TileUploader from '../tile-uploader';

export const Stack = BitrixVue.component('tile-uploader.stack', {
	mounted()
	{
		const tileUploader: TileUploader = this.$Bitrix.Application.get();
		tileUploader.getUploader().assignDropzone(this.$refs.container);
	},
	template: `<div class="ui-tile-uploader-stack" v-on:click="$emit('click')" ref="container">Stack</div>`
});
